import React from 'react';
import { motion } from 'framer-motion';
import { EmailWidget } from './EmailWidget';
import { O365Widgets } from './O365Widgets';
import { NewsFeed } from './NewsFeed';
import { RoomControls } from './RoomControls';
export function SoloDashboard() {
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} className="flex-1 grid grid-cols-12 gap-6 p-6 overflow-hidden" data-id="element-546">
      {/* Left Column - Email & Room Controls */}
      <div className="col-span-3 flex flex-col gap-6" data-id="element-547">
        <div className="flex-1" data-id="element-548">
          <EmailWidget data-id="element-549" />
        </div>
        <div className="h-[400px]" data-id="element-550">
          <RoomControls data-id="element-551" />
        </div>
      </div>

      {/* Center Column - O365 Widgets */}
      <div className="col-span-6" data-id="element-552">
        <O365Widgets data-id="element-553" />
      </div>

      {/* Right Column - News Feed */}
      <div className="col-span-3" data-id="element-554">
        <NewsFeed data-id="element-555" />
      </div>
    </motion.div>;
}